module.exports = __webpack_public_path__ + "media/img/frontend_application/coupon-green-70c1236acc3a206f6022c6c6d66aa6c3.png";